import React, { useCallback,useMemo ,useRef,useEffect, useState } from "react";
import ServiceNavigation from "../../redesign/components/Services/ServiceNavigation";
import SendInvitation from "./SendInvitationbutton";
import debuglog from "../../util/helperutil"; 
import {
  CssBaseline,
  Stack,
  TextField,
  MenuItem,
  IconButton,
  Alert,
  Autocomplete,
} from "@mui/material";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../eventComponent/EventTabs/EventTabs.css";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import {
  fetchchatGptData,
  fetchchatGptHowTo,
} from "../../Apiservices/Auth/servers/chatGptServer";
import {
  getServiceProvidersByID,
  fetchProviderData,
  getPriestsListByLocation,
  getTentHouseListByLocation,
  getCateringListByLocation,
} from "../../Apiservices/Auth/servers/fetchProviderData";
import { fetchReligionCaste } from "../../Apiservices/Auth/servers/fetchReligionCaste";
import { fetchLanguages } from "../../Apiservices/Auth/servers/fetchLanguages";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import LoadMap from "./LoadMap";
import config from "../../config";
import { capitalizeFirstLetter } from "../../util/typeCasting";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../../store/cartSlice";
import providerData from "../../ProviderServices.json";
//import ReligionAndCaste from "../../ReligionAndCaste.json";
import ButtonMailto from "../ButtonMailto";
import CreateEventCTA from "./CreateEventCTA";
import MyButton1 from "../CustomComponents/MyButton1";
import ProviderListingCard from "../ServiceProvider/ProviderListingCard";
import { Accordion, AccordionTab } from "primereact/accordion";
import Services from "../../ProviderServices.json";
import { fetchStates } from "../../Apiservices/Auth/servers/fetchStates";
import Navbar from "../../redesign/components/Navbar";
import Footer from "../../redesign/components/Footer";

function EventServices() {
  const sendInviteRef = useRef(null);
  const cart = useSelector((state) => state.cart.serviceList);
  const userDetails = useSelector((state) => state.user.userDetails);
  const dispatch = useDispatch();

  const checkForAdd = (itemId) => {
    const found = cart.find((opt) => opt.itemID === itemId);
    return found;
  };

  const addToService = (opt) => {
    dispatch(addToCart(opt));
  };

  const removeService = (opt) => {
    dispatch(removeFromCart(opt));
  };

  const [loading, setLoading] = useState(true);
  const [providerListLoading, setProvideListLoading] = useState(false);
  const [castes, setCastes] = useState([]);
  //const [providerData, setProviderData] = useState([]);
  const [providerInfo, setProviderInfo] = useState([]);
  const [ReligionAndCaste, setReligionAndCaste] = useState({});
  const [states, setStates] = useState([]);
  const [languages, setLanguages] = useState([]);

  const location = useLocation();
  const { serviceDetails, eventDetails } = location.state || {}; // Get event details

  // console.log(eventDetails);

  const {
    id,
    serviceName,
    serviceCardName,
    serviceDescription,
    serviceTitle,
    serviceSubTitle,
  } = serviceDetails;
  const { eventTitle, locationLat, locationLong, eventId } = eventDetails;

  const [eventStateTitle, setEventStateTitle] = useState(
    eventTitle ? eventTitle : ""
  );
  const [AIdialogVisible, setAIdialogvisible] = useState(false);
  const [howTo, setHowTO] = useState("");
  const [context, setcontext] = useState("");

  const navigate = useNavigate();

  const backtoEvents = () => {
    navigate("/dashboard");
  };

  const providerListStorageKey = config.providerListStorageKey;
  const providerList = localStorage.getItem(providerListStorageKey);

  if (providerList) {
    localStorage.removeItem(providerListStorageKey);
  }

  const fetchReligionCasteData = useCallback(async () => {
    setLoading(true);
    try {
      const ReligionCastedata = await fetchReligionCaste();
      setReligionAndCaste(ReligionCastedata);
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchLanguagesData = useCallback(async () => {
    setLoading(true);
    try {
      const LanguagesData = await fetchLanguages();
      setLanguages(LanguagesData);
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchStatesData = useCallback(async () => {
    setLoading(true);
    try {
      const states = await fetchStates();
      setStates(states);
    } catch (error) {
      console.error("Failed to fetch states:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchProviderList = useCallback(async () => {
    setProvideListLoading(true);
    try {
      let provider_data;

      switch (id) {
        case 7:
          provider_data = await getPriestsListByLocation(
            locationLat,
            locationLong,
            eventId
          );
          break;
        case 8:
          provider_data = await getTentHouseListByLocation(
            locationLat,
            locationLong,
            eventId
          );
          break;
        case 9:
          provider_data = await getCateringListByLocation(
            locationLat,
            locationLong,
            eventId
          );
          break;
      }
      setProviderInfo(provider_data.data);
      debuglog({'Providerinfo':provider_data})
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setProvideListLoading(false);
    }
  }, [id]);
// this is the issue
  useEffect(() => {
    //fetchProviders();
    fetchReligionCasteData();
    fetchStatesData();
    fetchLanguagesData();
    id !== 1 && fetchProviderList();
  }, [id]);
  const renderCount = useRef(1);
  useEffect(() => {
    renderCount.current += 1;
    debuglog(`Rendered ${renderCount.current} times`);
    
  });
  // console.log("providerInfo", providerInfo);

  // console.log("ReligionAndCaste", ReligionAndCaste);
  const [selectedService, setSelectedService] = useState(null);

  const [showInvitation, setShowInvitation] = useState(false);

  const handleclose = (status) => {
    console.log("Dialog closed with status:", status);
    setShowInvitation(false);
  };
  useEffect(() => {
    // Optionally add a side effect like analytics tracking, logging, etc.
    console.log("Invitation modal visibility changed:", showInvitation);
  }, [showInvitation]); // Dependency on showInvitation state
  const handleEventService = (service) => {
    const info = {
      serviceDetails: service,
      eventDetails:
        eventDetails && Object.keys(eventDetails).length > 0
          ? eventDetails
          : {},
    };    
    if (service.id === 2) {
      console.log("eventdetails",eventDetails)
      setSelectedService(service);
      setShowInvitation(true);
    } else {
      // Navigate to the "providers" page
      navigate("/providers", { state: info });
    }
  
    window.scrollTo({ top: 0 });
  };

  const handleProviderServcies = (provider) => {
    const info = {
      serviceDetails: serviceDetails,
      providerDetails: provider,
      eventDetails: eventDetails,
    };
    
    navigate("/provider/services", { state: info });
    window.scrollTo({ top: 0 });
  };

  function removeBlankAttributes(obj) {
    const result = {};
    for (const key in obj) {
      if (obj[key] !== "" && obj[key] !== undefined) {
        result[key] = obj[key];
      }
    }
    return result;
  }

  const setDefaultAIFormValues = (defaults = {}) => {
    formik.setValues({
      event: eventStateTitle || "",
      Location: "",
      Language: "",
      Religion: "",
      Caste: "",
      SubCaste: "",
      ...defaults, // allow overrides
    });
  };
  useEffect(() => {
    console.log("Ai clicked");
    if (id === 1 && howTo === "") {
      setLoading(true);
      if (eventDetails.eventMasterDetails?.is_priest_required) {
        setAIdialogvisible(true);
        // setLoading(false);
      } else {
        setDefaultAIFormValues({ Language: "Telugu", Religion: "Hindu" });
        setTimeout(() => {
          formik.handleSubmit(); // This will use the newly set values
          setLoading(false);
        }, 100);
      }
    }
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      Religion: "Hindu",
      Caste: "",
      SubCaste: "",
      Language: "Telugu",
      Location: "Telangana",
      event: eventStateTitle,
      Gothram:""
    },
    onSubmit: async (values, { resetForm }) => {
      const altered = removeBlankAttributes(values);

    const question = `
    Please generate a detailed event checklist for planning and organizing the ${altered?.event} ceremony in ${altered?.Location}, as per ${altered?.Religion} ${altered?.Caste} customs with ${altered?.SubCaste} subcaste, and spoken language being ${altered?.Language}.
    
    Use the following **JSON structure**, and return only meaningful and culturally appropriate data. Maintain subpoints (a, b, c, etc.) under all headings where applicable. Do not include empty or generic items. Use accurate cultural terminology (e.g., temple, mosque, church, hall, etc.).
    
    Only include the following headings and keys:
    
    {
      "1. Why / Story / History": {
        "a) Spiritual or Religious Significance": "Explain traditional or scriptural relevance",
        "b) Cultural Importance": "How the event is celebrated in community or region",
        "c) Emotional / Family Sentiment": "Generational or personal meaning for family"
      },
      "2. Pre-Event Planning": {
        "a) Decide the Venue – [temple/mosque/home/hall]": "Culturally appropriate advice on selecting venue",
        "b) Finalize the date/time – Consult elders or religious texts": "Rituals or consultations required",
        "c) Invite guests": "Preferred method and cultural norms",
        "d) Book required services – priest, decorator, caterer, etc.": "Whom to book and when"
      },
      "3. Materials Required": {
        "a) Religious Materials": "Puja samagri or other ritual materials",
        "b) Event-Specific Items": "Cake, flowers, lights, etc. depending on occasion",
        "c) General Supplies": "Chairs, water, fan, mats, etc."
      },
      "4. Setup Checklist": {
        "a) Decor Setup": "Decor elements such as garlands, rangoli, etc.",
        "b) Seating Arrangement": "Chairs, mats, stage area",
        "c) Sound System / Music": "Microphone, speakers, traditional music",
        "d) Ritual Area (if any)": "Setup for religious or ceremonial purpose"
      },
      "5. Formal Attire": {
        "a) For Host": "Traditional wear suggestion",
        "b) For Guests": "Dress code or guidelines",
        "c) For Religious Personnel (if applicable)": "What priest/imam/etc. should wear"
      },
      "6. Step-by-Step Event Proceedings": {
        "a) Opening / Welcome": "Opening mantra, greeting, or prayer",
        "b) Rituals / Celebration Steps": "Chronological steps with short explanations",
        "c) Blessings / Wishes": "When and who to invite for blessings or speeches",
        "d) Closing": "Concluding rituals or expressions of gratitude"
      },
      "7. Food": {
        "a) Prasadam / Offerings (if religious)": "Items for offering and sharing",
        "b) Meals / Snacks": "Menu suggestions based on culture",
        "c) Water & Beverages": "Water, juices, welcome drinks"
      },
      "8. Post Event Checklist": {
        "a) Clean-up": "Assigning cleanup responsibility",
        "b) Return of rented items / borrowed furniture": "Checklist and timing",
        "c) Collecting personal belongings": "Handling of lost/found",
        "d) Gratitude messages": "WhatsApp or printed thank-you notes"
      }
    }
    Return only valid and structured JSON with **realistic values**, no placeholders.
    `;
    

    try {
      setAIdialogvisible(false); // Hide dialog
      setLoading(true); // Show loading spinner

      const apiResponse = await fetchchatGptHowTo({ question });

      if (eventDetails.eventMasterDetails.is_priest_required) {
        setcontext(
          `Just as Grandma used to say, here are the essential steps followed for ${altered?.event}:`
        );
      }

      if (apiResponse?.answer) {
        const parsed = JSON.parse(apiResponse.answer);
        setHowTO(parsed);
      } else {
        console.warn("Empty or invalid response from AI");
      }
    } catch (error) {
      console.error("Failed to generate event checklist:", error);
    } finally {
      setLoading(false);
      if (resetForm) resetForm();
    }
  }});



  useEffect(() => {
    if (ReligionAndCaste?.religion?.length > 0) {
      const hinduReligion = { name: "Hindu" };
      handleReligionFieldChange("Religion", hinduReligion);
    }
  }, [ReligionAndCaste]);

  useEffect(() => {
    // Only update the form field if the user hasn't selected a location manually
    if (eventDetails?.state && formik.values.Location !== eventDetails.state) {
      formik.setFieldValue("Location", eventDetails?.state);
    }
  }, [eventDetails, formik.values.Location]);
  

  const textFieldStyles = {
    backgroundColor: "#ffffff",
    width: "100%",
    borderRadius: "4px",
    marginBottom: "0",
  };

  const setCasteByReligion = (value) => {
    const result = ReligionAndCaste.religion.find((obj) => obj.name === value);
    setCastes(result.castes);
  };

  // const handleReligionChange = (field) => (event) => {
  //   const value = event.target.value;
  //   formik.setFieldValue(field, value);
  //   setCasteByReligion(value);
  // };

  const handleReligionFieldChange = (field, value) => {
    formik.setFieldValue(field, value.name);
    setCasteByReligion(value.name);
  };

  const handleCasteFieldChange = (field, value) => {
    formik.setFieldValue(field, value.name);
  };

  const handleFieldChange = (field) => (event) => {
    const value = event.target.value;
    formik.setFieldValue(field, value);
  };

  const handleAIenabledService = () => {
    setAIdialogvisible(true);
  };

  const renderProviderListById = (item, id) => {
    if (id === 7) {
       debuglog({ "discountvalidupto": item.discountValidUpto, "discount type": typeof(item.discountValidUpto) });

      return (
        <ProviderListingCard
          key={item.id}
          latitude={item.latitude}
          longitude={item.longitude}
          name={`${item.firstName} ${item.lastName}`}
          address={item.formattedAddress}
          distance={item.distanceInMeter}
          mobile={item.mobile}
          email={item.email}
          price={item.price}
          discount={item.discountPrice}
          validUpto={item.discountValidUpto}
        />
      );
    } else if (id === 8) {
      return (
        <ProviderListingCard
          key={item.id}
          latitude={item.latitude}
          longitude={item.longitude}
          name={item.name}
          address={item.formattedAddress}
          distance={item.distanceInMeter}
          mobile={item.mobile}
          email={item.emailId}
          price={item.price}
          discount={item.discountPrice}
        />
      );
    } else if (id === 9) {
      return (
        <ProviderListingCard
          key={item.id}
          latitude={item.latitude}
          longitude={item.longitude}
          name={item.name}
          address={item.formattedAddress}
          distance={item.distanceInMeter}
          mobile={item.mobile}
          email={item.email}
          price={item.price}
          discount={item.discountPrice}
        />
      );
    }
  };

  const renderButtonOnCase = (sentence) => {
    return ""
    if (
      sentence?.toLowerCase()?.includes("purohit") ||
      sentence?.toLowerCase()?.includes("consult") ||
      sentence?.toLowerCase()?.includes("priest") ||
      sentence?.toLowerCase()?.includes("pooja") ||
      sentence?.toLowerCase()?.includes("puja") ||
      sentence?.toLowerCase()?.includes("homa")
    ) {
      const priestData = providerData?.find((data) => data.type === "Priest");
      return (
        <div
          className="event-service-head"
          style={{
            width: "max-content",
            padding: "5px",
            margin: "10px",
            cursor: "pointer",
            borderRadius: "10px",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          }}
          onClick={() => handleEventService(priestData)}
        >
          <div>
            <img
              style={{
                display: "block",
                width: "30px",
              }}
              src={`${process.env.PUBLIC_URL}/assets/images/${priestData.id}.png`}
              alt={priestData.serviceCardName}
            />
            <div>
              <h3>{priestData.serviceCardName}</h3>
            </div>
          </div>
          <div className="pi pi-chevron-right"></div>
        </div>
      );
    } else if (
      sentence?.toLowerCase()?.includes("invite") ||
      sentence?.toLowerCase()?.includes("invitation") ||
      sentence?.toLowerCase()?.includes("invitations")
    ) {
      const inviteData = providerData?.find((data) => data.type === "Invite");
      return (
        <div
          className="event-service-head"
          style={{
            width: "max-content",
            padding: "5px",
            margin: "10px",
            cursor: "pointer",
            borderRadius: "10px",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          }}
          onClick={() => handleEventService(inviteData)}
        >
          <div>
            <img
              style={{
                display: "block",
                width: "30px",
              }}
              src={`${process.env.PUBLIC_URL}/assets/images/${inviteData.id}.png`}
              alt={inviteData.serviceCardName}
            />
            <div>
              <h3>{inviteData.serviceCardName}</h3>
            </div>
          </div>
          <div className="pi pi-chevron-right"></div>
        </div>
      );
    } else if (
      sentence?.toLowerCase()?.includes("prasad") ||
      sentence?.toLowerCase()?.includes("prasadam") ||
      sentence?.toLowerCase()?.includes("food") ||
      sentence?.toLowerCase()?.includes("caterer") ||
      sentence?.toLowerCase()?.includes("catering") ||
      sentence?.toLowerCase()?.includes("cuisine") ||
      sentence?.toLowerCase()?.includes("veg") ||
      sentence?.toLowerCase()?.includes("non-veg")
    ) {
      const cateringData = providerData?.find(
        (data) => data.type === "Catering"
      );
      return (
        <div
          className="event-service-head"
          style={{
            width: "max-content",
            padding: "5px",
            margin: "10px",
            cursor: "pointer",
            borderRadius: "10px",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          }}
          onClick={() => handleEventService(cateringData)}
        >
          <div>
            <img
              style={{
                display: "block",
                width: "30px",
              }}
              src={`${process.env.PUBLIC_URL}/assets/images/${cateringData.id}.png`}
              alt={cateringData.serviceCardName}
            />
            <div>
              <h3>{cateringData.serviceCardName}</h3>
            </div>
          </div>
          <div className="pi pi-chevron-right"></div>
        </div>
      );
    } else if (
      sentence?.toLowerCase()?.includes("cultural") ||
      sentence?.toLowerCase()?.includes("program") ||
      sentence?.toLowerCase()?.includes("event")
    ) {
      const rentalsData = providerData?.find((data) => data.type === "Rentals");
      return (
        <div
          className="event-service-head"
          style={{
            width: "max-content",
            padding: "5px",
            margin: "10px",
            cursor: "pointer",
            borderRadius: "10px",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          }}
          onClick={() => handleEventService(rentalsData)}
        >
          <div>
            <img
              style={{
                display: "block",
                width: "30px",
              }}
              src={`${process.env.PUBLIC_URL}/assets/images/${rentalsData.id}.png`}
              alt={rentalsData.serviceCardName}
            />
            <div>
              <h3>{rentalsData.serviceCardName}</h3>
            </div>
          </div>
          <div className="pi pi-chevron-right"></div>
        </div>
      );
    }

    return <></>;
  };

  const renderSection = (sectionData) => {
    return Object.keys(sectionData).map((key) => {
      const value = sectionData[key];

      if (typeof value === "object") {
        return (
          <li key={key}>
            {key}
            <ol style={{ listStyle: "none" }}>
              {Object.keys(value).map((nestedKey) => (
                <li key={nestedKey}>
                  -{" "}
                  <span>
                    {value[nestedKey] }
                  </span>
                </li>
              ))}
            </ol>
          </li>
        );
      }

      return (
        <li key={key}>
          <span>
            
            {value }
          </span>
        </li>
      );
    });
  };

  return (
    <div style={{ width: "100%" }}>
      <CssBaseline />
      <Navbar />
      <div className="eventservice-main-container">
      {/* s */}
        <div className="frontend-container">
          <div style={{ width: "100%" }}>
            <div className="event-form-inner">
              <div
                className="event-form-body "
                // style={{
                //   gridTemplateColumns: id === 1 ? "unset" : "3.75fr 1.25fr",
                // }}
              >
                <div className="event-form-body-inner">
                  {/* <div
                    className="event-form-head banner"
                    style={{
                      backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/servicebanner/${id}.png)`,
                    }}
                  >
                    <div className="banner-content">
                      <h1>{serviceTitle}</h1>
                      <div className="sub-head">{serviceSubTitle}</div>
                    </div>
                  </div>                   */}
                 {/* {id === 1 && (
                    <div className="event-service-list sidebar flex-column lg:flex-row">
                      {providerData.length > 0 &&
                        providerData
                          .filter((item) => item.id !== id)
                          .map((item) => (
                            <div
                              key={item.id}
                              className="event-service justify-content-center"
                              onClick={() => handleEventService(item)}
                            >
                              <div className="event-service-head">
                                <div>
                                  <img
                                    style={{
                                      display: "block",
                                      width: "30px",
                                    }}
                                    src={`${process.env.PUBLIC_URL}/assets/images/${item.id}.png`}
                                    alt={item.serviceCardName}
                                  />
                                  <div>
                                    <h3>{item.serviceCardName}</h3>
                                    {/* <div className="event-rsvp">
                                    {item.serviceDescription}
                                   </div> */}
                                  {/* </div>
                                </div>
                                <div className="pi pi-chevron-right"></div>
                              </div>
                            </div>
                          ))}
                    </div>
                    

                  )} */} 
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      marginTop: "10px",
                      marginBottom: "10px",
                      paddingRight: "5px",
                    }}
                  >
                    <MyButton1
                      title="Back to Dashboard"
                      method={backtoEvents}
                      // icon="pi pi-arrow-left"
                    ></MyButton1>
                  </div>
                  {id === 1 ? (
                    <div className="event-providers">
                      {loading ? (
                        <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "200px", 
                          width: "100%",
                          marginTop: "40px", 
                        }}
                      >
                        <h3 style={{ margin: 0 }}>
                          <i
                            className="pi pi-spin pi-spinner-dotted"
                            style={{ fontSize: "2rem", color: "#0cc0df" }}
                          ></i>
                        </h3>
                      </div>
                      ) : (
                        <div
                          className={`event-service alter no-data ${
                            howTo && "alignleft"
                          }`}
                        >
                          {howTo ? (
                            <>                       
                              <p className="eventservice-body-header">{context}</p>
                              <div>
                                <Accordion activeIndex={null} className="Accordiandata">
                                  {Object.keys(howTo).map((sectionKey) => (
                                    <AccordionTab
                                      header={
                                        <h3 className="font-legal">
                                          {sectionKey}
                                        </h3>
                                      }
                                      key={sectionKey}
                                    >
                                      <ol type="1">
                                        {renderSection(howTo[sectionKey])}
                                      </ol>
                                    </AccordionTab>
                                  ))}
                                </Accordion>
                              </div>
                            </>
                          ) : (
                            <>
                              <h3>KNOW ABOUT YOUR EVENT</h3>
                              <h4>
                                Get to know what to do exactly (AI enabled).
                              </h4>

                              <Button
                                iconPos="right"
                                icon="pi pi-chevron-right"
                                className="custom-button"
                                label="Get AI enabled Process"
                                onClick={handleAIenabledService}
                                size="small"
                              />
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="event-providers">
                      {providerListLoading ? (
                        <h3 style={{ textAlign: "center" }}>
                          <i
                            className="pi pi-spin pi-spinner-dotted"
                            style={{ fontSize: "2rem", color: "#0cc0df" }}
                          ></i>
                        </h3>
                      ) : providerInfo.length > 0 ? (
                        providerInfo.map((item) => {
                          // const hasValidServices =
                          //   item.events && item.events.length > 0 && item.price;
                          return renderProviderListById(item, id);

                          // <div
                          //   key={item.id}
                          //   className="event-service"
                          //   onClick={() => {
                          //     if (hasValidServices) {
                          //       console.log(
                          //         "There is prices we can directly add them "
                          //       );
                          //     } else {
                          //       handleProviderServcies(item);
                          //     }
                          //   }}
                          // >
                          //   {item.latitude && item.longitude && (
                          //     <LoadMap
                          //       locationLat={item.latitude}
                          //       locationLong={item.longitude}
                          //       width="100px"
                          //       height="100px"
                          //     />
                          //   )}
                          //   <div className="event-service-head">
                          //     <div className="event-service-headtop">
                          //       <h3>
                          //         {item.firstName} {item.lastName}
                          //       </h3>
                          //     </div>
                          //     <div>
                          //       <LocationOnOutlinedIcon className="plicon" />
                          //       {item.formattedAddress.length > 0
                          //         ? item.formattedAddress
                          //         : "Address not avaliable."}
                          //     </div>
                          //     <div className="bottom">
                          //       {item.distance !== null && (
                          //         <>
                          //           <RouteOutlinedIcon className="plicon" />
                          //           {`${(item.distance / 1000).toFixed(
                          //             1
                          //           )} km`}
                          //         </>
                          //       )}{" "}
                          //       <PhoneAndroidOutlinedIcon className="plicon" />
                          //       {item?.mobileNumber}
                          //     </div>
                          //   </div>
                          //   {/* {hasValidServices ? (
                          //     <div className="event-providerservcies full">
                          //       <div
                          //         key={item.services[0].serviceMaster.id}
                          //         className={`event-service alter ${
                          //           cart &&
                          //           cart.length > 0 &&
                          //           checkForAdd(
                          //             `${
                          //               item.services[0].service_master_id
                          //             }_${
                          //               item.services[0].service_provider_id
                          //             }_${
                          //               eventDetails &&
                          //               Object.keys(eventDetails).length > 0
                          //                 ? eventDetails.id
                          //                 : 0
                          //             }`
                          //           ) &&
                          //           "sel-event"
                          //         }`}
                          //       >
                          //         <div className="event-service-headtop">
                          //           <div
                          //             style={{ margin: 0, lineHeight: 1 }}
                          //             className="desc"
                          //           >
                          //             <small>Service:</small>
                          //           </div>
                          //           <h3>
                          //             {
                          //               item.services[0].serviceMaster
                          //                 .serviceName
                          //             }
                          //           </h3>
                          //           {new Date(
                          //             item.services[0].discountValidUpto
                          //           ) > new Date() &&
                          //           item.services[0].discountPrice ? (
                          //             <div className="price">
                          //               <s>&#8377;{item.services[0].price}</s>
                          //               <br />
                          //               <strong>
                          //                 &#8377;
                          //                 {item.services[0].discountPrice}
                          //               </strong>
                          //               <span
                          //                 style={{
                          //                   color: "red",
                          //                   fontSize: "20px",
                          //                 }}
                          //               >
                          //                 *
                          //               </span>
                          //             </div>
                          //           ) : (
                          //             <div className="price">
                          //               <strong>
                          //                 &#8377;{item.services[0].price}
                          //               </strong>
                          //             </div>
                          //           )}
                          //           {new Date(
                          //             item.services[0].discountValidUpto
                          //           ) > new Date() && (
                          //             <div className="validupto">
                          //               <span
                          //                 style={{
                          //                   color: "red",
                          //                   fontSize: "20px",
                          //                 }}
                          //               >
                          //                 *
                          //               </span>{" "}
                          //               Valid upto{" "}
                          //               {format(
                          //                 new Date(
                          //                   item.services[0].discountValidUpto
                          //                 ),
                          //                 "MMMM dd, yyyy"
                          //               )}
                          //             </div>
                          //           )}
                          //         </div>
                          //         <div className="event-service-middle">
                          //           {cart &&
                          //           cart.length > 0 &&
                          //           checkForAdd(
                          //             `${
                          //               item.services[0].service_master_id
                          //             }_${
                          //               item.services[0].service_provider_id
                          //             }_${
                          //               eventDetails &&
                          //               Object.keys(eventDetails).length > 0
                          //                 ? eventDetails.id
                          //                 : 0
                          //             }`
                          //           ) ? (
                          //             <Button
                          //               icon="pi pi-minus"
                          //               className="custom-button cancel"
                          //               label="Remove Service"
                          //               size="small"
                          //               style={{ width: "100%" }}
                          //               onClick={() =>
                          //                 removeService({
                          //                   itemID: `${
                          //                     item.services[0]
                          //                       .service_master_id
                          //                   }_${
                          //                     item.services[0]
                          //                       .service_provider_id
                          //                   }_${
                          //                     eventDetails &&
                          //                     Object.keys(eventDetails)
                          //                       .length > 0
                          //                       ? eventDetails.id
                          //                       : 0
                          //                   }`,
                          //                 })
                          //               }
                          //             />
                          //           ) : (
                          //             <Button
                          //               icon="pi pi-plus"
                          //               className="custom-button"
                          //               label="Add Service"
                          //               size="small"
                          //               style={{ width: "100%" }}
                          //               onClick={() =>
                          //                 addToService({
                          //                   itemID: `${
                          //                     item.services[0]
                          //                       .service_master_id
                          //                   }_${
                          //                     item.services[0]
                          //                       .service_provider_id
                          //                   }_${
                          //                     eventDetails &&
                          //                     Object.keys(eventDetails)
                          //                       .length > 0
                          //                       ? eventDetails.id
                          //                       : 0
                          //                   }`,
                          //                   service: `${item.services[0].serviceMaster.serviceName}`,
                          //                   provider: `${item.firstName} ${item.lastName}`,
                          //                   event: `${
                          //                     eventDetails &&
                          //                     Object.keys(eventDetails)
                          //                       .length > 0
                          //                       ? eventDetails.eventTitle
                          //                       : null
                          //                   }`,
                          //                   amount:
                          //                     new Date(
                          //                       item.services[0].discountValidUpto
                          //                     ) > new Date() &&
                          //                     item.services[0].discountPrice
                          //                       ? item.services[0]
                          //                           .discountPrice
                          //                       : item.services[0].price,
                          //                 })
                          //               }
                          //             />
                          //           )}
                          //         </div>
                          //       </div>
                          //     </div>
                          //   ) : (
                          //     <div className="pi pi-chevron-right"></div>
                          //   )} */}
                          // </div>
                        })
                      ) : (
                        <div className="event-service alter no-data">
                          <h3>
                            No {serviceName} in your area for the {eventTitle}
                          </h3>
                          <h4>SEND US A MESSAGE - WE WILL CONTACT YOU</h4>
                          <ButtonMailto
                            label="Send E-Mail"
                            mailto={config.emailAddress}
                            subject={`No ${serviceName} (service provider's) available in my area`}
                            body={`Hello,\n\nNo ${serviceName} (service providers) available in my area for the ${eventTitle}.\nPlease let me know when it's available.\n\n\nThanks,\n${
                              userDetails.firstName &&
                              capitalizeFirstLetter(userDetails.firstName)
                            }\n${
                              userDetails.mobileNumber &&
                              userDetails.mobileNumber
                            }`}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
                  {/* event services nav bar */}
                {id !== 0 && (
                  <div className="event-service-list sidebar">
                    <div
                      className="sidebar-inner"
                      style={{ paddingTop: "100px" }}
                    >
                      {providerData.length > 0 &&
                        providerData
                          .filter((item) => item.id !== id)
                          .map((item) => (
                            <div
                              key={item.id}
                              className="event-service-button"
                              onClick={() => handleEventService(item)}
                            >
                              <div className="event-service-head">
                                <div>
                                  <img
                                    style={{
                                      display: "block",
                                      width: "30px",
                                    }}
                                    src={`${process.env.PUBLIC_URL}/assets/images/${item.id}.png`}
                                    alt={item.serviceCardName}
                                  />
                                  <div>
                                    <h3>{item.serviceCardName}</h3>
                                    {/* <div className="event-rsvp">
                                    {item.serviceDescription}
                                   </div> */}
                                  </div>
                                </div>
                                {/* <div className="pi pi-chevron-right"></div> */}
                              </div>
                              
                            </div>
                          ))}
                          {showInvitation && (
        <SendInvitation event={eventDetails} onClose={handleclose} />
      )}
                    </div>
                  </div>
                )}

                {id === 1 && (
                  <Dialog
                    header={`AI enabled Service ${eventStateTitle}`}
                    visible={AIdialogVisible}
                    style={{
                      width: "calc(100% - 15px)",
                      maxWidth: "400px",
                    }}
                    modal
                    onHide={() => {setAIdialogvisible(false)
                      navigate("/dashboard");
                    }
                    }
                  >
                    <form
                      onSubmit={formik.handleSubmit}
                      style={{ width: "100%", border: 0 }}
                    >
                      <div className="event-service-head-inner">
                        <div className="event-chantgpt-fields">
                          {eventStateTitle ? (
                            <TextField
                              type="hidden"
                              name="event"
                              value={formik.values.event}
                              style={{ position: "absolute", zIndex: -1 }}
                            />
                          ) : (
                            <TextField
                              size="small"
                              name="event"
                              label="Enter Event"
                              value={formik.values.event}
                              onChange={handleFieldChange("event")} // Use common change handler
                              variant="outlined"
                              sx={textFieldStyles}
                            />
                          )}
                          <Autocomplete
                            size="small"
                            sx={textFieldStyles}
                            options={states}
                            getOptionLabel={(option) => option.name}
                            value={
                              states.find(
                                (option) =>
                                  option.name === formik.values.Location
                              ) || null
                            }
                            onInputChange={(event, newInputValue) => {
                              // Trigger the formik value change when the input value changes
                              formik.setFieldValue("Location", newInputValue);
                            }}
                            onChange={(event, newValue) => {
                              // Update formik value when the user selects an option
                              formik.setFieldValue(
                                "Location",
                                newValue?.name || ""
                              );
                            }}
                            filterOptions={(options, state) => {
                              // Show only options with 2 or more characters matching the input
                              return options.filter((option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Region / State"
                                variant="outlined"
                                name="Location"
                                sx={textFieldStyles}
                              />
                            )}
                            disableClearable
                            loading={states.length === 0} // Show a loading indicator if no languages are available
                          />
                          <Autocomplete
                            size="small"
                            sx={textFieldStyles}
                            options={languages}
                            getOptionLabel={(option) => option.name}
                            value={
                              languages.find(
                                (option) =>
                                  option.name === formik.values.Language ||
                                  option.name ===
                                    states.find(
                                      (state) =>
                                        state.name === formik.values.Location
                                    )?.defaultLanguage
                              ) || null
                            }
                            onInputChange={(event, newInputValue) => {
                              // Trigger the formik value change when the input value changes
                              formik.setFieldValue("Language", newInputValue);
                            }}
                            onChange={(event, newValue) => {
                              // Update formik value when the user selects an option
                              formik.setFieldValue(
                                "Language",
                                newValue?.name || ""
                              );
                            }}
                            filterOptions={(options, state) => {
                              // Show only options with 2 or more characters matching the input
                              return options.filter((option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Language"
                                variant="outlined"
                                name="Language"
                                sx={textFieldStyles}
                              />
                            )}
                            disableClearable
                            loading={languages.length === 0} // Show a loading indicator if no languages are available
                          />
                          <Autocomplete
                            size="small"
                            sx={textFieldStyles}
                            options={ReligionAndCaste?.religion || []}
                            getOptionLabel={(option) => option.name}
                            value={
                              ReligionAndCaste?.religion?.find(
                                (option) =>
                                  option.name === formik.values.Religion
                              ) || null
                            }
                            onInputChange={(event, newInputValue) => {
                              // Trigger the formik value change when the input value changes
                              formik.setFieldValue("Religion", newInputValue);
                            }}
                            onChange={(event, newValue) =>
                              handleReligionFieldChange("Religion", newValue)
                            }
                            filterOptions={(options, state) => {
                              // Show only options with 2 or more characters matching the input
                              return options.filter((option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Religion"
                                variant="outlined"
                                name="Religion"
                                sx={textFieldStyles}
                              />
                            )}
                            disableClearable
                            loading={ReligionAndCaste?.religion?.length === 0} // Show a loading indicator if no religions are available
                          />

                          <Autocomplete
                            size="small"
                            sx={textFieldStyles}
                            options={castes || []}
                            getOptionLabel={(option) => option.name}
                            value={
                              castes.find(
                                (option) => option.name === formik.values.Caste
                              ) || null
                            }
                            onInputChange={(event, newInputValue) => {
                              // Trigger the formik value change when the input value changes
                              formik.setFieldValue("Caste", newInputValue);
                            }}
                            onChange={(event, newValue) =>
                              handleCasteFieldChange("Caste", newValue)
                            }
                            filterOptions={(options, state) => {
                              // Show only options with 2 or more characters matching the input
                              return options.filter((option) =>
                                option.name
                                  .toLowerCase()
                                  .includes(state.inputValue.toLowerCase())
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Caste"
                                variant="outlined"
                                name="Caste"
                                sx={textFieldStyles}
                              />
                            )}
                            disableClearable
                            loading={castes.length === 0} // Show a loading indicator if no castes are available
                          />

                          <TextField
                            size="small"
                            variant="outlined"
                            name="SubCaste"
                            label="Select Sub Caste"
                            value={formik.values.SubCaste}
                            onChange={handleFieldChange("SubCaste")}
                            sx={textFieldStyles}
                          />
                          <TextField
                            size="small"
                            variant="outlined"
                            name="Gothram"
                            label="Enter host Gothram"
                            value={formik.values.Gothram}
                            onChange={handleFieldChange("Gothram")}
                            sx={textFieldStyles}
                          />
                          <span
                            style={{
                              fontSize: "10px",
                              color: "#737373",
                            }}
                          >
                            WE ONLY COLLECT THIS INFORMATION TO GIVE YOU
                            SUITABLE DETAILS AND FILTER SERVICES, AND NOT FOR
                            ANY OTHER REASON
                          </span>
                          <Button
                            style={{ width: "100%" }}
                            type="submit"
                            className="custom-button"
                            label="Submit"
                          />
                        </div>
                      </div>
                    </form>
                  </Dialog>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

export default EventServices;
